var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("我的证书")]),_c('a-divider'),_c('CertQuery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }